import { FC } from 'react'

import { Button } from '@/components/lemmala-design-system/button/button'

export type SettingsPageSaveButtonsProps = {
  isSaving?: boolean
  onCancel?: () => void
  onSave?: () => void
  isSaveDisabled?: boolean
  isCancelDisabled?: boolean
}
export const SettingsPageSaveButtons: FC<SettingsPageSaveButtonsProps> = ({
  isSaving,
  onCancel,
  onSave,
  isSaveDisabled,
  isCancelDisabled,
}) => {
  return (
    <div className='flex items-center gap-2'>
      <Button variant='ghost' onClick={onCancel} disabled={isSaving || isCancelDisabled}>
        Cancel
      </Button>
      <Button onClick={onSave} disabled={isSaveDisabled}>
        {isSaving ? 'Saving...' : 'Save'}
      </Button>
    </div>
  )
}
